export const black = '#000000';
export const white = '#ffffff';
export const chambray = '#2e4487';
export const ice = '#dfe6f0';
export const sapphire = '#0d2880';
export const night = '#07184d';
export const gray = '#7A7A7A';
export const cod = '#1a1a1a';
